import React from 'react'
import ReactDOM from 'react-dom/client'

import './index.css'
import App from './App.jsx'

//ReactDOM.createRoot(document.getElementById('home')).render(<App />);
ReactDOM.createRoot(document.getElementById('home')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
